(function () {
    'use strict';

    var nav = document.getElementById('nav');
    var burger = document.getElementById('burger');
    var mobileMenu = document.getElementById('mobileMenu');

    // Scroll-based nav styling
    if (nav) {
        window.addEventListener('scroll', function () {
            if (window.scrollY > 100) {
                nav.classList.add('nav--scrolled');
            } else {
                nav.classList.remove('nav--scrolled');
            }
        });
    }

    // Mobile menu toggle
    if (burger && mobileMenu) {
        burger.addEventListener('click', function () {
            burger.classList.toggle('active');
            mobileMenu.classList.toggle('active');

            if (mobileMenu.classList.contains('active')) {
                if (window.apollonLenis) window.apollonLenis.stop();
                if (typeof gsap !== 'undefined') {
                    gsap.fromTo('.mobile-menu__link',
                        { y: 40, opacity: 0 },
                        {
                            y: 0, opacity: 1,
                            stagger: 0.08,
                            duration: 0.6,
                            ease: 'power3.out',
                            delay: 0.2
                        }
                    );
                }
            } else {
                if (window.apollonLenis) window.apollonLenis.start();
            }
        });

        // Close mobile menu on regular link click
        document.querySelectorAll('.mobile-menu__link:not(.mobile-menu__toggle)').forEach(function (link) {
            link.addEventListener('click', function () {
                burger.classList.remove('active');
                mobileMenu.classList.remove('active');
                if (window.apollonLenis) window.apollonLenis.start();
            });
        });

        // Close mobile menu on sublink click
        document.querySelectorAll('.mobile-menu__sublink').forEach(function (link) {
            link.addEventListener('click', function () {
                burger.classList.remove('active');
                mobileMenu.classList.remove('active');
                if (window.apollonLenis) window.apollonLenis.start();
            });
        });

        // Accordion toggle for mega menu items
        document.querySelectorAll('.mobile-menu__toggle').forEach(function (toggle) {
            toggle.addEventListener('click', function () {
                var parentItem = this.closest('.mobile-menu__item');
                var isActive = parentItem.classList.contains('active');

                // Close all open submenus (accordion — one at a time)
                document.querySelectorAll('.mobile-menu__item.active').forEach(function (item) {
                    item.classList.remove('active');
                });

                // Open clicked one if it wasn't already open
                if (!isActive) {
                    parentItem.classList.add('active');
                }
            });
        });
    }
})();
